import { Modal } from "@mantine/core";
import styles from "./unsaved-changes-modal.module.scss";

interface UnsavedChangesModalProps {
  isOpen: boolean;
  onContinueEditing: () => void;
  onLeave: () => void;
}

export function UnsavedChangesModal({
  isOpen,
  onContinueEditing,
  onLeave,
}: UnsavedChangesModalProps) {
  return (
    <Modal
      opened={isOpen}
      onClose={onContinueEditing}
      closeOnClickOutside={true}
      closeOnEscape={true}
      withCloseButton={false}
      classNames={{
        content: styles.modalContent,
        body: styles.modalBody,
      }}
      centered
      size={531}
    >
      <div className={styles.modal}>
        <div className={styles.modalHeader}>
          <h2 className={styles.modalTitle}>You have unsaved changes</h2>
          <p className={styles.modalMessage}>
            If you leave now, your changes will not be saved.
          </p>
        </div>
        <div className={styles.modalActions}>
          <button
            className={`${styles.button} ${styles.leaveButton}`}
            onClick={onLeave}
            type="button"
          >
            Leave Without Saving
          </button>
          <button
            className={`${styles.button} ${styles.continueButton}`}
            onClick={onContinueEditing}
            type="button"
          >
            Continue Editing
          </button>
        </div>
      </div>
    </Modal>
  );
}
